import React, { useEffect, useState } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin, { Draggable } from "@fullcalendar/interaction";
import esLocale from '@fullcalendar/core/locales/es'
import { Card, Row, Col, Modal, Button } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux";
import { PaymentDetails } from "./PaymentDetails";


export const PaymentScheduleCalendar = ({ code, isOpen, setIsOpen }) => {
  const dispatch = useDispatch();
  const { paymentSchedule } = useSelector((state) => state.group);
  const [eventSelected, setEventSelected] = useState({});
  const [ showDetails, setShowDetails ] = useState(false);

  function renderEventContent(eventInfo) {
    const event = eventInfo.event.title.split("\n");
    return (
      <>

        <b>{eventInfo.timeText}</b>
        <i>{event[0]}</i>
        <br />
        <i>{event[1]}</i>
      </>
    );
  }
  const handleEventClick = (clickInfo) => {    

    let event = paymentSchedule.events.find(x => x.id == clickInfo.event.id);
    if (event) {

      if (event.tipo == 'pago') {
        setEventSelected(event);
        setShowDetails(true);
      }
    }
  };
  const handleEvents = (events) => { };

  const handleDateSelect = (selectInfo) => {  };
  return (
    <Modal
      size="xl"
      show={isOpen}
      aria-labelledby="example-modal-sizes-title-lg"
    >
      <Modal.Header>
        <Modal.Title >
          Calendario De Pagos
        </Modal.Title>
        <Button
          onClick={() => setIsOpen(false)}
          className="btn-close"
          variant=""
        >
          x
        </Button>
      </Modal.Header>
      <Modal.Body>
      <Row>
        <Col md={12}>
          <Card>
            <Card.Header>
              <h3 className="card-title">
                Pagos Agendados
              </h3>
            </Card.Header>
            <Card.Body>
              <Row>
                {
                  !paymentSchedule.isLoading &&
                  <Col md={12} >
                    <div className="fullclndr">
                      <FullCalendar
                        locale={esLocale}
                        plugins={[
                          dayGridPlugin,
                          timeGridPlugin,
                          interactionPlugin,
                        ]}
                        headerToolbar={{
                          left: "prev,next today",
                          center: "title",
                          right: "dayGridMonth,timeGridWeek,timeGridDay",
                        }}
                        initialView="dayGridMonth"
                        editable={false}
                        selectable={true}
                        selectMirror={true}
                        dayMaxEvents={true}
                        weekends={true}
                        initialEvents={paymentSchedule.events}
                        select={handleDateSelect}
                        eventContent={renderEventContent}
                        eventClick={handleEventClick}
                        eventsSet={handleEvents}
                      />
                    </div>
                  </Col>
                }
              </Row>

              <PaymentDetails payment={eventSelected} isOpen={showDetails} setIsOpen={setShowDetails}  />
            </Card.Body>
          </Card>
        </Col>
      </Row>
      </Modal.Body>
    </Modal>
  );
}
